import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const inspectorsColumns: GridColumnConfig[] = [
  // {
  //   title: 'Match Percentage Skill',
  //   field: 'matchPercentageSkill',
  //   filter: 'text',
  //   searchable: true,
  //   width: '150',
  // },
  // {
  //   title: 'Match Percentage Equipment',
  //   field: 'matchPercentageEquipment',
  //   filter: 'text',
  //   searchable: true,
  //   width: '150',
  // },
  {
    title: 'ID',
    field: 'userID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Primary Inspector',
    field: 'userName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Market Area',
    field: 'userMarketAreas',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Skill Sets',
    field: 'userSkillsets',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Equipments',
    field: 'userEquipments',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Calendar',
    field: 'calendar',
    filter: 'text',
    searchable: true,
  },
];
